export default __webpack_public_path__ + "static/media/youtube.47522daf.svg";